import Parser from 'html-react-parser'
import PropTypes from 'prop-types'
import React from 'react'

import { syntaxHighlight } from './JsonView.utils'

const propTypes = {
  /**
   * json object
   */
  rawJson: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * If true, apply color to rendered json based on the property type
   */
  colorize: PropTypes.bool,
}

function JsonView(props) {
  const { rawJson = {}, colorize = false } = props ?? {}

  const json = JSON.stringify(rawJson, null, 3)
  // eslint-disable-next-line no-unused-vars
  const parsed = colorize ? Parser(syntaxHighlight(json)) : json

  return (
    <div className="jsonViewWrapper">
      <pre className="font-size-default">{parsed}</pre>
    </div>
  )
}

JsonView.propTypes = propTypes

export default JsonView
